import { FC } from 'react'
import { InnerContainer } from './styles'
import { useTranslation } from '../../../hooks/locale'
import { SeoRegionsGrid } from '../../common/seo-region-grid'
import { SeoItemsTransport } from '../../../transports/home-page-transport'
import { Section, Title, TitleContainer } from '../common/styles'

interface OtherPopularRegionProps {
    regions: SeoItemsTransport[]
}

const OtherPopularRegionSection: FC<OtherPopularRegionProps> = ({ regions }) => {
    const { t } = useTranslation()

    return (
        <Section id="other-popular-region">
            <TitleContainer>
                <Title> {t('pages.home.otherPopularRegions.heading')} </Title>
            </TitleContainer>
            <InnerContainer>
                <SeoRegionsGrid regions={regions} keyPrefix="other-popular-region" />
            </InnerContainer>
        </Section>
    )
}

export default OtherPopularRegionSection
